import { FC } from 'react';

import Link from 'next/link';
import Image from 'next/image';

import { LogoContainer } from './styles';
import logo from '../../../../public/promptx.png';

export const Logo: FC = () => {
  return (
    <LogoContainer>
      <Link href="/prompts">
        <Image src={logo} alt="Prompts Mestres Logo" width={160} />
      </Link>
    </LogoContainer>
  );
};
